
import { Gender } from "./Gender";
import { Validation } from "./Validation";
import ImageJson, { validateImageJson, validateImageJsonAdd } from "./ImageJson";
import DemoServer from "./DemoServer";

/**
 * Kunde für eine Buchung mit Informationen über das Kind, für das gebucht wird.
 */
export default interface CustomerJson {
   ID: number | null;
   guardianFirstName: string;
   guardianLastName: string;
   guardianOrganisation: string;
   email: string;
   phone: string;
   idDocuments: ImageJson[];

   addressStreet: string;
   addressZip: string;
   addressCity: string;
   addressCountry: string;

   childFirstName: string;
   childLastName: string;
   childBirthDate: string | null;
   childGender: Gender;
   childGradeLevel: number | null,
   childSchoolClass: string,
   holidayBookingGroup: string,

   remarks: string,
}

export function defaultCustomerJson() {
   return {
      ID: null,
      guardianFirstName: "",
      guardianLastName: "",
      guardianOrganisation: "",
      email: DemoServer.isActive ? DemoServer.demoEmail : "",
      phone: "",
      idDocuments: [],
      addressStreet: "",
      addressZip: "",
      addressCity: "",
      addressCountry: "Deutschland",
      childFirstName: "",
      childLastName: "",
      childBirthDate: "",
      childGender: Gender.female,
      childGradeLevel: null,
      childSchoolClass: "",
      holidayBookingGroup: "",
      remarks: "",
   };
}

export function validateBirthdayBookingCustomerJsonAddNew(item: CustomerJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateNonEmptyString("childFirstName", 100)
      .validateNonEmptyString("childLastName", 100)
      .validatePastDate("childBirthDate")
      .validateNumber("childGradeLevel", 0, 15, true)
      .validateString("childSchoolClass", 100)
      .validateString("holidayBookingGroup", 100)
      .validateString("remarks", 1000)
      .finish();
}

export function validateBirthdayBookingCustomerJson(item: CustomerJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateNonEmptyString("childFirstName", 100)
      .validateNonEmptyString("childLastName", 100)
      .validatePastDate("childBirthDate")
      .validateNumber("childGradeLevel", 0, 15, true)
      .validateString("childSchoolClass", 100)
      .validateString("holidayBookingGroup", 100)
      .validateString("remarks", 1000)
      .finish();
}
export function validateWorkshopCustomerJsonAddNew(item: CustomerJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateNonEmptyString("childFirstName", 100)
      .validateNonEmptyString("childLastName", 100)
      .validatePastDate("childBirthDate")
      .validateNumber("childGradeLevel", 0, 15, true)
      .validateString("childSchoolClass", 100)
      .validateString("holidayBookingGroup", 100)
      .validateString("remarks", 1000)
      .finish();
}

export function validateWorkshopCustomerJson(item: CustomerJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateNonEmptyString("childFirstName", 100)
      .validateNonEmptyString("childLastName", 100)
      .validatePastDate("childBirthDate")
      .validateNumber("childGradeLevel", 0, 15, true)
      .validateString("childSchoolClass", 100)
      .validateString("holidayBookingGroup", 100)
      .validateString("remarks", 1000)
      .finish();
}

export function validateGroupBookingCustomerJsonAddNew(item: CustomerJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateNonEmptyString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateString("remarks", 1000)
      .finish();
}


export function validateGroupBookingCustomerJson(item: CustomerJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateNonEmptyString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateString("remarks", 1000)
      .finish();
}

export function validateHolidayProgramBookingCustomerJsonAddNew(item: CustomerJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateNonEmptyString("childFirstName", 100)
      .validateNonEmptyString("childLastName", 100)
      .validatePastDate("childBirthDate")
      .validateNumber("childGradeLevel", 0, 15)
      .validateString("childSchoolClass", 100)
      .validateString("holidayBookingGroup", 100)
      .validateString("remarks", 1000)
      .finish();
}
export function validateHolidayProgramBookingCustomerJson(item: CustomerJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateNonEmptyString("childFirstName", 100)
      .validateNonEmptyString("childLastName", 100)
      .validatePastDate("childBirthDate")
      .validateNumber("childGradeLevel", 0, 15)
      .validateString("childSchoolClass", 100)
      .validateString("holidayBookingGroup", 100)
      .validateString("remarks", 1000)
      .finish();
}

export function validateMemberCustomerJsonForm(item: CustomerJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateString("childFirstName", 100)
      .validateString("childLastName", 100)
      .validateNumber("childGradeLevel", 0, 15, true)
      .validateString("childSchoolClass", 100)
      .validateString("holidayBookingGroup", 100)
      .validateString("remarks", 1000)
      .finish();
}
export function validateMemberCustomerJsonAddNew(item: CustomerJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email", true)
      .validateString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateString("childFirstName", 100)
      .validateString("childLastName", 100)
      .validateNumber("childGradeLevel", 0, 15, true)
      .validateString("childSchoolClass", 100)
      .validateString("holidayBookingGroup", 100)
      .validateString("remarks", 1000)
      .finish();
}
export function validateMemberCustomerJson(item: CustomerJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email", true)
      .validateString("phone", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateString("childFirstName", 100)
      .validateString("childLastName", 100)
      .validateNumber("childGradeLevel", 0, 15, true)
      .validateString("childSchoolClass", 100)
      .validateString("holidayBookingGroup", 100)
      .validateString("remarks", 1000)
      .finish();
}
export function validateMemberChildCustomerJson(item: CustomerJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateString("guardianFirstName", 100)
      .validateString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateString("phone", 100)
      .validateString("addressStreet", 100)
      .validateString("addressZip", 100)
      .validateString("addressCity", 100)
      .validateString("addressCountry", 100)
      .validateNonEmptyString("childFirstName", 100)
      .validateNonEmptyString("childLastName", 100)
      .validateNumber("childGradeLevel", 0, 15, true)
      .validateString("childSchoolClass", 100)
      .validateString("holidayBookingGroup", 100)
      .validateString("remarks", 1000)
      .finish();
}

export function validateRentalBookingCustomerJson(item: CustomerJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)

      .validateAllUsingFunction("idDocuments", validateImageJson, 0, false, 4)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateString("remarks", 1000)
      .finish();
}
export function validateRentalBookingCustomerJsonRequest(item: CustomerJson, requestDriversLicense: boolean = false) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateAllUsingFunction("idDocuments", validateImageJsonAdd, requestDriversLicense ? 1 : 0, false, 4)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateString("remarks", 1000)
      .finish();
}
export function validateRentalBookingCustomerJsonAdd(item: CustomerJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("guardianFirstName", 100)
      .validateNonEmptyString("guardianLastName", 100)
      .validateString("guardianOrganisation", 100)
      .validateEmail("email")
      .validateNonEmptyString("phone", 100)
      .validateAllUsingFunction("idDocuments", validateImageJsonAdd, 0, false, 4)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateString("remarks", 1000)
      .finish();
}
export function validateMailingCustomerJson(item: CustomerJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, false)
      .validateEmail("email")
      .finish();
}
